import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

const GoogleAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const googleAuthStatus = searchParams.get('google_auth');
      const message = searchParams.get('message');

      if (googleAuthStatus === 'success') {
        // Se estamos em um popup, avisar a janela pai
        if (window.opener) {
          window.opener.postMessage('google_auth_success', '*');
          setTimeout(() => window.close(), 1000);
        } else {
          // Se não é popup, redirecionar
          setTimeout(() => navigate('/agendamento'), 2000);
        }
      } else if (googleAuthStatus === 'error') {
        console.error('Erro na autenticação Google:', message);
        // Se estamos em um popup, avisar a janela pai
        if (window.opener) {
          window.opener.postMessage('google_auth_error', '*');
          setTimeout(() => window.close(), 2000);
        } else {
          // Se não é popup, redirecionar
          setTimeout(() => navigate('/agendamento'), 3000);
        }
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  const googleAuthStatus = searchParams.get('google_auth');
  const message = searchParams.get('message');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        p: 3
      }}
    >
      {googleAuthStatus === 'success' ? (
        <>
          <CircularProgress color="success" />
          <Typography variant="h6" color="success.main">
            ✅ Conectado com sucesso!
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Fechando janela...
          </Typography>
        </>
      ) : googleAuthStatus === 'error' ? (
        <>
          <Alert severity="error" sx={{ mb: 2 }}>
            ❌ Erro ao conectar com Google Calendar
          </Alert>
          <Typography variant="body2" color="text.secondary">
            {message || 'Erro desconhecido'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Redirecionando...
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography variant="h6">
            Processando autenticação...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default GoogleAuthCallback;
